import { waLink, WHATSAPP_INTENTS } from "../config";

export default function MobileStickyBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-background-50 border-t border-background-200 p-3 grid grid-cols-2 gap-2">
      <a
        href="#menu"
        className="inline-flex items-center justify-center gap-2 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer"
      >
        <i className="ri-restaurant-line"></i>
        MENÜYÜ GÖR
      </a>
      <a
        href={waLink(WHATSAPP_INTENTS.hero)}
        target="_blank"
        rel="nofollow noopener"
        className="inline-flex items-center justify-center gap-2 py-3.5 rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer"
      >
        <i className="ri-whatsapp-line text-lg"></i>
        WHATSAPP
      </a>
    </div>
  );
}